<template>
  <div class="autocomplete-input" :class='styling'>
      <input v-model="keyword" class="input" @focus='searchFocus' @input="onInput($event.target.value)" @keyup.esc="isOpen = false" @blur="searchBlur" @keydown.down="moveDown" @keydown.up="moveUp" @keydown.enter="select" :placeholder="searchPlaceholder" :autofocus="styling === 'inheader'">
    <ul v-show="isOpen" class="options-list">
      <li v-for="(option, index) in fOptions" :class="{
          'highlighted': index === highlightedPosition
        }" @mouseenter="highlightedPosition = index" @mousedown="select">
        <slot name="item" :title="option.title" :description="option.description" :thumbnail="option.thumbnail">
          <article class="media">
            <p v-if='option.name'>
              <strong>{{ option.name }}</strong>
              <span>{{option.category}} ({{ option.plcount }})</span>
            </p>
            <p v-if='option.plno && option.photos'>
              <strong>PL{{ option.plno }}</strong>
              <span>Location</span>
            </p>
            <p v-if='option.address && !option.tags'>
              <strong>{{ option.address }}</strong>
              <span>PL{{ option.plno }}</span>
            </p>
          </article>
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    searchPlaceholder: {
      type: String
    },
    styling: {
      type: String
    }
  },
  data () {
    return {
      isOpen: false,
      highlightedPosition: 0,
      keyword: ''
    }
  },
  watch: {
    highlightedPosition: function () {
      var container = this.$el.querySelector('ul')
      var itemIndex = this.highlightedPosition + 1
      var highlightedElement = this.$el.querySelector('li:nth-child(' + itemIndex + ')')
      if (container.scrollTop + container.clientHeight < highlightedElement.offsetTop + highlightedElement.offsetHeight) container.scrollTop = highlightedElement.offsetTop + highlightedElement.offsetHeight - container.clientHeight
      if (container.scrollTop > highlightedElement.offsetTop) container.scrollTop = highlightedElement.offsetTop
    }
  },
  computed: {
    fOptions () {
      var searchfor = this.keyword
      if (typeof searchfor !== 'string') return false
      if (searchfor.length < 2) return false
      if (searchfor.substr(0, 2).toUpperCase() === 'PL') {
        searchfor = searchfor.substring(2)
        if (this.keyword.length === 2) return false
      }
      const re = new RegExp(searchfor, 'i')
      var pls = this.$root.PLs.filter(o => o.plno.match(re))
      var tags = []
      this.$root.categories.forEach(function (category) {
        var matchingtags = category.tags.filter(o => o.name.match(re))
        matchingtags.forEach(function (tag) {
          tag.category = category.name
        })
        tags = tags.concat(matchingtags)
      })
      if (this.$root.addresses.length > 0) {
        tags = tags.concat(this.$root.addresses.filter(function (address) {
          if (typeof address.address === 'string') return address.address.match(re)
        }))
      }
      return pls.concat(tags)
    }
  },
  methods: {
    onInput (value) {
      this.highlightedPosition = 0
      this.isOpen = !!value
    },
    moveDown () {
      if (!this.isOpen) {
        return
      }
      this.highlightedPosition =
        (this.highlightedPosition + 1) % this.fOptions.length
    },
    moveUp () {
      if (!this.isOpen) {
        return
      }
      this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.fOptions.length - 1 : this.highlightedPosition - 1
    },
    select () {
      const selectedOption = this.fOptions[this.highlightedPosition]
      this.$emit('select', selectedOption)
      this.isOpen = false
      this.keyword = selectedOption.title
    },
    searchFocus () {
      this.$emit('searchFocus')
    },
    searchBlur () {
      this.isOpen = false
      this.$emit('searchBlur')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
ul {
  list-style-type: none;
  padding: 0;
  max-height: 20em;
  overflow-y: scroll;
}

li {
  display: inline-block;
  margin: 0 10px;
}

input {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.autocomplete-input {
  position: relative;
  max-height: 140px;
  @include bp(most) {
    max-height: 300px;
  }
}

ul.options-list {
  display: flex;
  flex-direction: column;
  margin-top: -2px;
  border: 1px solid #dbdbdb;
  border-radius: 0 0 3px 3px;
  position: absolute;
  width: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
}

ul.options-list li {
  width: 100%;
  flex-wrap: wrap;
  background: white;
  margin: 0;
  border-bottom: 1px solid #eee;
  color: #363636;
  padding: 7px;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  p {
    margin: 0px;
    padding: .375em .785em;
  }
  strong {
    display: inline-block;
  }
  span {
    display: block;
    float: right;
    font-weight: 200;
    color: $darkgrey;
  }
}

ul.options-list li.highlighted {
  background: $yellow;
}

.inheader {
  input {
    width: 100%;
    box-sizing: border-box;
    background: none;
    border: 0px;
    outline: none;
    border-radius: 0px;
    border-bottom: 1px solid $notblack;
    font-family: $noto;
    font-size: 14px;
    font-weight: 600;
    &::placeholder {
      font-weight: 200;
      color: $notblack;
    }
  }
  ul.options-list {
    border-top: 0px none;
      margin-top: 0px;
    @include bp(most) {
      margin-top: -13px;
    }
  }

  ul.options-list li {
    p {
      padding: 0 .5em;
      line-height: 1.75;
      font-size: 12px;
      text-transform: none;
    }
    strong {
      display: inline-block;
    }
    span {
      display: block;
      float: right;
      font-weight: 200;
      color: $darkgrey;
    }
  }

}

</style>



// WEBPACK FOOTER //
// Autocomplete.vue?18ad004b